import { reduxMultiple } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxMultiple.HR.LEARNING()
export { reducer, actions, saga }
